module.exports = __webpack_public_path__ + "img/lock2.d5723179.png";